// SMS APIs

/**
 * @function ApiClient#SendResetSMSCode
 * @this {ApiClient}
 * @param {any} account
 * @param {any} mobile
 * @param {any} options = {}
 */
export async function SendResetSMSCode(account, mobile, options = {}) {
  return await this._post(`/sendcommunityresetsms?a=${account}&m=${mobile}`, null, options);
}
